"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_accessor_1 = require("../content-accessor");

var string_1 = require("../../util/string");

var asset_accessor_1 = require("../asset-accessor");

var contentful_asset_accessor_1 = require("./contentful-asset-accessor");

var ContentfulContentAccessor =
/** @class */
function () {
  function ContentfulContentAccessor(base) {
    this.base = base;
  }

  ContentfulContentAccessor.prototype.hasBaseFields = function () {
    return !!this.base && !!this.base.fields;
  };

  ContentfulContentAccessor.prototype.raw = function () {
    return this.base && this.base.fields;
  };

  ContentfulContentAccessor.prototype.field = function (name) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return new ContentfulContentAccessor(value);
    }

    return new content_accessor_1.NullAccessor();
  };

  ContentfulContentAccessor.prototype.array = function (name) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return value.map(function (v) {
        return new ContentfulContentAccessor(v);
      });
    }

    return [];
  };

  ContentfulContentAccessor.prototype.text = function (name, defaultValue) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return value;
    }

    return defaultValue;
  };

  ContentfulContentAccessor.prototype.longText = function (name, defaultValue) {
    if (this.base) {
      var value = this.base.fields[name];
      return value;
    }

    return defaultValue;
  };

  ContentfulContentAccessor.prototype.richText = function (name, defaultValue) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return value;
    }

    return defaultValue;
  };

  ContentfulContentAccessor.prototype.slug = function (name, defaultValue) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return string_1.slugify(value);
    }

    return defaultValue;
  };

  ContentfulContentAccessor.prototype.number = function (name, defaultValue) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return value;
    }

    return defaultValue;
  };

  ContentfulContentAccessor.prototype["boolean"] = function (name, defaultValue) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return value;
    }

    return defaultValue;
  };

  ContentfulContentAccessor.prototype.asset = function (name) {
    if (this.hasBaseFields() && this.base.fields[name]) {
      var value = this.base.fields[name];
      return new contentful_asset_accessor_1.ContentfulAssetAccessor(value);
    }

    return new asset_accessor_1.NullAssetAccessor();
  };

  ContentfulContentAccessor.prototype.type = function () {
    if (this.base) {
      if (this.base['sys'] && this.base['sys']['contentType'] && this.base['sys']['contentType']['sys']) {
        return "Contentful" + string_1.capitalize(this.base['sys']['contentType']['sys']['id']);
      }

      console.error("ContentfulContentAccessor: type() requested on a entry sys.contentType.sys.id");
      return 'unknown';
    }

    return 'null';
  };

  ContentfulContentAccessor.prototype.file = function (name) {
    return new asset_accessor_1.NullFileAccessor();
  };

  return ContentfulContentAccessor;
}();

exports.ContentfulContentAccessor = ContentfulContentAccessor;